module.exports = __webpack_public_path__ + "img/mastercard.3ab31ea.svg";